import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Parallax from "../Components/ui/Parallax";

interface TransitionProps {
  onFinish: () => void;
  passedTitle?: string;
  id?: string;
}

const TransitionOverlay = styled.div<{ $isActive: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  visibility: ${({ $isActive }) => ($isActive ? "visible" : "hidden")};
  transition: opacity 0.5s, visibility 0.5s;

  .title,
  .image {
    transform: ${({ $isActive }) => ($isActive ? "scale(1)" : "scale(0)")};
    transition: transform 0.5s ease-in-out;
  }

  .image {
    width: 150px;
    height: 150px;
  }

  .title {
    font-size: 4rem;
    font-weight: 400;
    text-align: center;
  }
`;

const PageTransition: React.FC<TransitionProps> = ({
  onFinish,
  passedTitle,
  id,
}) => {
  const [isActive, setIsActive] = useState(true);
  const location = useLocation();

  // Default to generic title
  let title = "Anim";

  // Match fixed paths
  if (location.pathname === "/") {
    title = "Home";
  } else if (location.pathname === "/work") {
    title = "Work";
  } else if (location.pathname === "/about") {
    title = "About";
  } else if (location.pathname === "/contact") {
    title = "Contact";
  }
  // Handle dynamic path
  else if (
    location.pathname.startsWith("/project-view/") ||
    (location.pathname.startsWith("/dashboard/landing/project-view") && id)
  ) {
    title = passedTitle ?? "Project";
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsActive(false);
      onFinish(); // Call the onFinish callback to indicate transition is done
    }, 1800); // Display for 1.5 second

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <TransitionOverlay $isActive={isActive}>
      <Parallax offset={-50}>
        <div className="title">{title}</div>
      </Parallax>
    </TransitionOverlay>
  );
};

export default React.memo(PageTransition);
